import { RouteConfig } from 'vue-router';
import ServiceModel from '@/modules/infodayco/service-model/views/ServiceModel.vue';
import Tutorials from '@/modules/infodayco/tutorials/views/Tutorials.vue';
import InfodaycoUpload from '@/modules/infodayco/upload/views/InfodaycoUpload.vue';

export const infodaycoRouter: RouteConfig[] = [
    {
        path: 'infodayco/service-model',
        name: 'service model',
        component: ServiceModel,
    },
    {
        path: 'infodayco/tutorials',
        name: 'tutorials',
        component: Tutorials,
    },
    {
        path: 'infodayco/management',
        name: 'infodayco management',
        component: InfodaycoUpload,
    },
];
